module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"economicalStatus":"Economical status","incomplete":"Incomplete","notSettled":"Not settled","settled":"Settled","invoiced":"Invoiced","recorded":"Recorded","cancelled":"Cancelled"},"no":{"economicalStatus":"Økonomisk status","incomplete":"Ufullstendig","notSettled":"Ikke klarert","settled":"Klarert","invoiced":"Oppgjort","recorded":"Bokført","cancelled":"Annullert"}}')
  delete Component.options._Ctor
}
